import { Component, ElementRef, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { timer } from 'rxjs';
import { HttpRequestService } from 'src/app/http-request.service';
import { LoaderService } from 'src/app/loader.service';

import { FacePercentage } from '../ai-dream-cam/classes/FacePercentage';

import { RequestsService } from '../ai-dream-cam/services/requests.service';
import { WebcamService } from '../ai-dream-cam/services/webcam.service';
import { DOCUMENT } from '@angular/common';

declare const gtag:Function

@Component({
  selector: 'app-sd-dream-cam',
  templateUrl: './sd-dream-cam.component.html',
  styleUrls: ['./sd-dream-cam.component.scss'],

})


export class SdDreamCamComponent implements OnInit {


  @ViewChild("videoPlayer")
  videoPlayer!: ElementRef;
  facePercentage: FacePercentage = new FacePercentage()

  @Output() imageEmitter = new EventEmitter<string>();

  @Output() SelfieStatus = new EventEmitter();
  @Input() selfie_state: boolean = false;
  hidebutton: any;
  Mobileno: string;
  kyc_decision_status: any;
  kyc_decision: any;
  Loader: boolean = false;

  Loader1: boolean = false;
  
  count2: number=0;
  sid: string;
  cameraError:boolean=false;
  imagesizeerror: boolean=false;
  private webengage:any;
  constructor(
    private requestsService: RequestsService,
    private webcamService: WebcamService,
    private service: HttpRequestService,
    private activeModal: NgbActiveModal,
    private loader: LoaderService,
    @Inject(DOCUMENT) private document: Document

  ) { }

  async ngOnInit(): Promise<void> {
    this.cameraError=false
    this.webengage = this.document.defaultView?.webengage;
  }

  Image: boolean = false;
  button: boolean = false;

  async ngAfterViewInit() {

    await this.toggleCamera()

  }
 

  async toggleCamera(): Promise<void> {

    try {

      await this.webcamService.toggleCamera(this.videoPlayer)
          } catch (error) {
       this.cameraError=true;
      alert("No webcam found!")

    }

  }

  async retrySnapshot(): Promise<void> {
    this.button = false;
    this.successImageData = undefined
    this.processing = false
    this.success = false

  }

  successImageData: string | undefined
  processing: boolean = false
  success: boolean = false

  async processSnapshot(): Promise<void> {
    this.processing = true
   
    this.Mobile=sessionStorage.getItem(this.Mobile);

    const body={
      Request_Key:'',
      Mobile:this.Mobile,
      Event_Name:'Take Selfie',
      Event_Type:'Button',
      Origin:'Frontend',
      Partner_Name:'DMI Finance',
      Remark_1:'',
      Remark_2:'',
      Remark_3:'',
      Remark_4:'',
      Remark_5:''
    
    }
    
    this.service.getEventTrack(body).subscribe(res => {

    });
    try {

      const imageBase64Data = await this.webcamService.getJpegSnapshot(
        this.videoPlayer
      )
      await timer(1000).toPromise()

      this.processing = true
      this.successImageData = imageBase64Data
      if (this.check_size(this.successImageData)) {
        // this.router.navigate(['techanical-error'])
        this.imagesizeerror=true;
        // console.log(this.imagesizeerror,'imageerror')
        this.processing = false;
        const body={
          Request_Key:'',
          Mobile:sessionStorage.getItem('Mobile'),
          Event_Name:'Image size error',
          Event_Type:'Button',
          Origin:'Frontend',
          Partner_Name:'DMI Finance',
          Remark_1:'',
          Remark_2:'',
          Remark_3:'',
          Remark_4:'',
          Remark_5:''
        
        }
        this.service.getEventTrack(body).subscribe(res => {
  
        });
       
      return;
    }
  





     
      this.processing = false
      this.success = true
      this.button = true;
    } catch (error) {


    }

  }
  // submitImage(){

  // }

  application_id;
  Mobile
  response
  checkcallbackstatus() {


    const body={

      Mobile:sessionStorage.getItem('Mobile')
    }
    this.service.callback(body).subscribe(res => {

       this.kyc_decision_status = res.Data.KYC_Status;

   

      
      if (this.kyc_decision_status == 'Approved') {
        this.webengage.track("KYC Photo Verification Successful");

       

        this.loader.hide();
        this.Loader = false;

        this.currentModal.dismiss();
        this.webcamService.currentStream.getTracks().forEach((track) => { track.stop(); });

        this.selfie_state = true;
        sessionStorage.setItem('selfiestatus', '1');
        this.showloader = false;
        this.SelfieStatus.emit({ status: 'Success', value: 1, response: res });


      }

      else if (this.kyc_decision_status == 'Retry') {

        this.webcamService.currentStream.getTracks().forEach((track) => { track.stop(); });

        this.selfie_state = false;
        this.showloader = false;
        this.currentModal.dismiss();
        this.SelfieStatus.emit({ status: 'Retry', value: 1, response: res });

      }
      else if (this.kyc_decision_status == 'Rejected') {
        this.webcamService.currentStream.getTracks().forEach((track) => { track.stop(); });

        this.selfie_state = false;
        this.showloader = false;
        this.currentModal.dismiss();
        this.SelfieStatus.emit({ status: 'Fail', value: 1, response: res });

      }
      else {
        // this.sendStatus.emit({status:'KycFail',value:1,response:''});
        this.count2+=1; 
        if(this.count2<=800) 
        { 
          this.webcamService.currentStream.getTracks().forEach((track) => { track.stop(); });

          setTimeout(() => {
            this.checkcallbackstatus();            
    
            
          }, 1000);  
         
          
        } 
        else{

          const body={
            Request_Key:'',
            Mobile:sessionStorage.getItem('Mobile'),
            Event_Name:'Technical Error - Selfie callback not received',
            Event_Type:'Button',
            Origin:'Frontend',
            Partner_Name:'DMI Finance',
            Remark_1:'',
            Remark_2:'',
            Remark_3:'',
            Remark_4:'',
            Remark_5:''
          
          }
          this.service.getEventTrack(body).subscribe(res => {

          });
          this.SelfieStatus.emit({status: 'Fail', value: 1, response: res }); 
          this.currentModal.dismiss();
          this.selfie_state = false;
          this.showloader = false;
          return
          
        }
      
    }


    }, err => {
      setTimeout(() => {
        this.checkcallbackstatus();
      }, 5000);

      return;
    });
  }
  showloader: boolean = false;
  async submitImage() {
     this.webengage.track("KYC Photo Submitted");
  
    // this.hidebutton = !this.hidebutton;
    
  
  this.showloader = true;

    this.application_id = sessionStorage.getItem('Application_id');
    this.Mobileno = sessionStorage.getItem('Mobile')
    const body1={
      Request_Key:'',
      Mobile:sessionStorage.getItem('Mobile'),
      Event_Name:'Submit Selfie',
      Event_Type:'Button',
      Origin:'Frontend',
      Partner_Name:'DMI Finance',
      Remark_1:'',
      Remark_2:'',
      Remark_3:'',
      Remark_4:'',
      Remark_5:''
    
    }
    this.service.getEventTrack(body1).subscribe(res => {

    });
    const body = {

      Mobile: this.Mobileno,
      Application_Id: this.application_id,
      Selfie: this.successImageData

    };

    this.showloader = true;
    
    this.service.take_selfie(body).subscribe(res => {
      

      this.response = res.Data;
      if (this.response == true) {
        

        this.checkcallbackstatus();

        // this.loader.hide();
        //           this.Loader = false;
        //           this.currentModal.dismiss();
        //           this.webcamService.currentStream.getTracks().forEach((track) => { track.stop(); });

        //           this.selfie_state = true;
        //           sessionStorage.setItem('selfiestatus', '1');
        //           this.SelfieStatus.emit({ status: 'Success', value: 1, response: res });



      }
      else {
      }

    })

    this.successImageData;

  }
  check_size(image:String)
  {
    const stringLength = image.length - 'data:image/png;base64,'.length;
    const sizeInBytes = 4 *Math.ceil((stringLength / 3))*0.5624896334383812;

    if (sizeInBytes /1000 <= 12) {
      return true;
    }
    return false;

  }


  get currentModal() {
    return this.activeModal;
  }
  ngOnDestroy(): void {
    // this.processSnapshot()
    // this.submitImage();
    // this.endIntervalSubject.next(null);
  }
}
